/**
 * ContainerScroll — 3D perspective scroll animation.
 * Converted from TypeScript/Tailwind to plain JSX + inline styles.
 * Based on Aceternity UI's container-scroll-animation.
 */
import React, { useRef } from 'react';
import { useScroll, useTransform, motion } from 'framer-motion';

/* ── Core component ── */
export const ContainerScroll = ({ titleComponent, children }) => {
  const containerRef = useRef(null);
  const { scrollYProgress } = useScroll({ target: containerRef });

  const [isMobile, setIsMobile] = React.useState(false);
  React.useEffect(() => {
    const check = () => setIsMobile(window.innerWidth <= 768);
    check();
    window.addEventListener('resize', check);
    return () => window.removeEventListener('resize', check);
  }, []);

  const scaleDimensions = isMobile ? [0.7, 0.9] : [1.05, 1];
  const rotate    = useTransform(scrollYProgress, [0, 1], [20, 0]);
  const scale     = useTransform(scrollYProgress, [0, 1], scaleDimensions);
  const translate = useTransform(scrollYProgress, [0, 1], [0, -100]);

  return (
    <div
      ref={containerRef}
      style={{
        height: isMobile ? '60rem' : '80rem',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative',
        padding: isMobile ? '0.5rem' : '5rem',
      }}
    >
      <div style={{ paddingTop: isMobile ? '2.5rem' : '10rem', paddingBottom: isMobile ? '2.5rem' : '10rem', width: '100%', position: 'relative', perspective: '1000px' }}>
        <ScrollHeader translate={translate} titleComponent={titleComponent} />
        <ScrollCard rotate={rotate} translate={translate} scale={scale}>
          {children}
        </ScrollCard>
      </div>
    </div>
  );
};

export const ScrollHeader = ({ translate, titleComponent }) => (
  <motion.div
    style={{ translateY: translate, maxWidth: '64rem', margin: '0 auto', textAlign: 'center' }}
  >
    {titleComponent}
  </motion.div>
);

export const ScrollCard = ({ rotate, scale, children }) => (
  <motion.div
    style={{
      rotateX: rotate,
      scale,
      marginTop: '-3rem',
      maxWidth: '64rem',
      margin: '-3rem auto 0',
      height: 'clamp(300px, 40vw, 640px)',
      width: '100%',
      border: '3px solid rgba(184,134,11,0.4)',
      padding: '0.5rem',
      background: 'linear-gradient(135deg, #1a1208 0%, #0d0d0d 50%, #1a1208 100%)',
      borderRadius: 30,
      boxShadow: '0 0 #0000004d, 0 9px 20px #0000004a, 0 37px 37px #00000042, 0 84px 50px #00000026, 0 149px 60px #0000000a',
    }}
  >
    <div style={{ height: '100%', width: '100%', overflow: 'hidden', borderRadius: 22, background: '#111' }}>
      {children}
    </div>
  </motion.div>
);
